var AppointmentTypeAgeGroup;
(function(AppointmentTypeAgeGroup) {
    AppointmentTypeAgeGroup["ADULT"] = "ADULT";
    AppointmentTypeAgeGroup["CHILD"] = "CHILD";
    AppointmentTypeAgeGroup["SENIOR"] = "SENIOR";
})(AppointmentTypeAgeGroup || (AppointmentTypeAgeGroup = {}));
var Dominance;
(function(Dominance) {
    Dominance["D"] = "D";
    Dominance["N"] = "N";
})(Dominance || (Dominance = {}));
var EyeSide;
(function(EyeSide) {
    EyeSide["BOTH"] = "BOTH";
    EyeSide["LEFT"] = "LEFT";
    EyeSide["RIGHT"] = "RIGHT";
})(EyeSide || (EyeSide = {}));
var OrderDeliveryMethod;
(function(OrderDeliveryMethod) {
    OrderDeliveryMethod["HOME_DELIVERY"] = "HOME_DELIVERY";
    OrderDeliveryMethod["HOME_DELIVERY_EXPRESS"] = "HOME_DELIVERY_EXPRESS";
    OrderDeliveryMethod["NEAREST_PICK_UP"] = "NEAREST_PICK_UP";
    OrderDeliveryMethod["PICK_UP"] = "PICK_UP";
    OrderDeliveryMethod["PICK_UP_POINT"] = "PICK_UP_POINT";
})(OrderDeliveryMethod || (OrderDeliveryMethod = {}));
var OrderPaymentMethod;
(function(OrderPaymentMethod) {
    OrderPaymentMethod["APPLE_PAY"] = "APPLE_PAY";
    OrderPaymentMethod["BANCONTACT_CARD"] = "BANCONTACT_CARD";
    OrderPaymentMethod["BANCONTACT_MOBILE"] = "BANCONTACT_MOBILE";
    OrderPaymentMethod["CARD"] = "CARD";
    OrderPaymentMethod["CASH_ON_DELIVERY"] = "CASH_ON_DELIVERY";
    OrderPaymentMethod["FAKE"] = "FAKE";
    OrderPaymentMethod["GOOGLE_PAY"] = "GOOGLE_PAY";
    OrderPaymentMethod["IDEAL"] = "IDEAL";
    OrderPaymentMethod["KLARNA"] = "KLARNA";
    OrderPaymentMethod["KLARNA_ACCOUNT"] = "KLARNA_ACCOUNT";
    OrderPaymentMethod["MBWAY"] = "MBWAY";
    OrderPaymentMethod["MOBILEPAY"] = "MOBILEPAY";
    OrderPaymentMethod["MULTIBANCO"] = "MULTIBANCO";
    OrderPaymentMethod["ONEY"] = "ONEY";
    OrderPaymentMethod["ONEY_3X"] = "ONEY_3X";
    OrderPaymentMethod["ONEY_4X"] = "ONEY_4X";
    OrderPaymentMethod["PAYPAL"] = "PAYPAL";
    OrderPaymentMethod["SEPA"] = "SEPA";
    OrderPaymentMethod["SWISH"] = "SWISH";
})(OrderPaymentMethod || (OrderPaymentMethod = {}));
var OrderPaymentStatus;
(function(OrderPaymentStatus) {
    OrderPaymentStatus["BALANCE_DUE"] = "BALANCE_DUE";
    OrderPaymentStatus["CREDIT_OWED"] = "CREDIT_OWED";
    OrderPaymentStatus["FAILED"] = "FAILED";
    OrderPaymentStatus["PAID"] = "PAID";
    OrderPaymentStatus["PENDING"] = "PENDING";
})(OrderPaymentStatus || (OrderPaymentStatus = {}));
var OrderShipmentStatus;
(function(OrderShipmentStatus) {
    OrderShipmentStatus["BACK_ORDER"] = "BACK_ORDER";
    OrderShipmentStatus["DELAYED"] = "DELAYED";
    OrderShipmentStatus["PARTIAL"] = "PARTIAL";
    OrderShipmentStatus["PENDING"] = "PENDING";
    OrderShipmentStatus["READY"] = "READY";
    OrderShipmentStatus["SHIPPED"] = "SHIPPED";
})(OrderShipmentStatus || (OrderShipmentStatus = {}));
var PrescriptionType;
(function(PrescriptionType) {
    PrescriptionType["CONTACT_LENS_PRESCRIPTION"] = "CONTACT_LENS_PRESCRIPTION";
    PrescriptionType["HEARING_AID_PRESCRIPTION"] = "HEARING_AID_PRESCRIPTION";
    PrescriptionType["PRESCRIPTION_GLASSES_PRESCRIPTION"] = "PRESCRIPTION_GLASSES_PRESCRIPTION";
})(PrescriptionType || (PrescriptionType = {}));

export { AppointmentTypeAgeGroup, Dominance, EyeSide, OrderDeliveryMethod, OrderPaymentMethod, OrderPaymentStatus, OrderShipmentStatus, PrescriptionType };
//# sourceMappingURL=sharedTypes.js.map
